import { t } from "@/i18n-js/instance";
import { CurrentPostContextProvider } from "@circle-react/contexts";
import { Typography } from "@circle-react-uikit/Typography";
import { FeaturedEvent } from "./FeaturedEvent";

export const FeaturedEventItem = ({
  event,
  onDestroy,
  onRsvp,
  isNextEvent,
  isThumbnailView,
}: any) => (
  <CurrentPostContextProvider post={event}>
    <div className="mb-6 ml-6 mt-3 md:ml-0">
      <Typography.TitleSm weight="bold">
        {isNextEvent ? t("events.next_event") : t("events.featured_event")}
      </Typography.TitleSm>
    </div>
    <div className="mx-6 sm:mx-0">
      <FeaturedEvent
        onDestroy={onDestroy}
        onRsvp={onRsvp}
        isNextEvent={isNextEvent}
        isThumbnailView={isThumbnailView}
      />
    </div>
  </CurrentPostContextProvider>
);
